import cn from 'classnames';
import styles from './ConfirmButtonGroup.module.css';

type Props = {
  /** Smoosh buttons left or right on desktop */
  variant?: 'left' | 'right';
  /** The primary action in the {@link ConfirmButtonGroup}, often `Save` or `Confirm` */
  primaryButton: React.ReactNode;
  /** The secondary action in the {@link ConfirmButtonGroup}, often `Cancel` or `Clear` */
  secondaryButton?: React.ReactNode;
  /** Optional children for extra actions in {@link ConfirmButtonGroup}, will be below/behind the primary/secondary actions */
  children?: React.ReactNode;
};

/**
 *
 * {@link ConfirmButtonGroup} takes a set of confirm buttons and orders them differently based on viewport size.
 * This is an evolution of `Spacer` to support reordering the primary button on top while on mobile.
 * Can be used in floating and full page modals forms.
 */
export function ConfirmButtonGroup({ variant = 'left', primaryButton, secondaryButton, children }: Props) {
  if (variant === 'right') {
    return (
      <>
        <div className={cn(styles.ConfirmButtonGroup, styles.ConfirmButtonGroup___mobileOrder)}>
          {primaryButton}
          {secondaryButton}
          {children}
        </div>
        <div className={cn(styles.ConfirmButtonGroup, styles.ConfirmButtonGroup___desktopOrder)}>
          {children}
          {secondaryButton}
          {primaryButton}
        </div>
      </>
    );
  }

  return (
    <div className={cn(styles.ConfirmButtonGroup, styles.ConfirmButtonGroup___variantLeft)}>
      {primaryButton}
      {secondaryButton}
      {children}
    </div>
  );
}
